import { useEffect, useState } from "react";
import AddButton from "../../../../components/AddButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import TableFilters from "../TableFilters";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { addStateMGA, editStateMGA, selectedRowsStateMGA } from "./atoms/atoms";
import { useGetMGA } from "./hooks/useGetMGA";
import useAddMGA from "./hooks/useAddMGA";
import useDeleteMGA from "./hooks/useDeleteMGA";
import useUpdateMGA from "./hooks/useUpdateMGA";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import MaterialProducerCodeConfigTable from "../../../../components/tables/MaterialProducerCodeConfigTable";

const MGATable = () => {
  const queryClient = useQueryClient();
  const [mGAData, setMGAData] = useState([]);
  const [editRowData, setEditRowData] = useState();
  const [addState, setAddState] = useRecoilState(addStateMGA);
  const [editState, setEditState] = useRecoilState(editStateMGA);
  const [rowsCount, setRowsCount] = useState(0);
  const newRow = {
    id: 0,
    mga1: "",
    createdOn: null,
    createdBy: null,
    isActive: true,
  };

  const [newData, setNewData] = useState([newRow]);

  const [openModal, setOpenModal] = useState(false);

  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsStateMGA);
  const [disableSave, setDisableSave] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [, setDisabledButton] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [updatedStatus, setUpdatedStatus] = useState(false);

  const [mgaFilteredData, setMgaFilteredData] = useState([]);
  const [, setProdCodeTypeFilteredData] = useState([]);
  const [, setLOBTypeFilteredData] = useState([]);
  const [, setCProgramFilteredData] = useState([]);
  const [, setDisChannelFilteredData] = useState([]);
  const [, setCodeLevelFilteredData] = useState([]);

  const MGAData = useGetMGA();
  const BulkDeleteMGA = useDeleteMGA();
  const editMGA = useUpdateMGA();
  const { mutateAsync: addMGA } = useAddMGA();

  //Permission
  const hasEdit = PERMISSIONS.permission_utilities_mga_edit;
  const hasAdd = PERMISSIONS.permission_utilities_mga_add;
  const hasDelete = PERMISSIONS.permission_utilities_mga_delete;
  const userPermissions = useRecoilValue(permissionsSelector);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  //Filter
  const [mgaId, setMgaId] = useState("");
  useEffect(() => {
    if (filterText) {
      setMGAData(
        MGAData.data.filter((x) =>
          x.mga1.toLowerCase().includes(filterText.trim().toLowerCase())
        )
      );
    } else if (mgaId?.includes(".")) {
      let mgaIds = mgaId.split(".");
      const mgaIdsArr = mgaIds.map((id) => Number(id));
      const filteredData = MGAData.data?.filter((x) =>
        mgaIdsArr.includes(x.id)
      );

      setMgaFilteredData(filteredData);
    } else if (mgaFilteredData?.length === 1) {
      const filteredData = MGAData.data?.filter((x) => x.id === Number(mgaId));
      setMgaFilteredData(filteredData);
    } else {
      setMGAData(MGAData.data);
    }
    setEditState(false);
    setAddState(false);
  }, [filterText, MGAData.data]);

  //Cancel
  const handleCancel = () => {
    setEditState(false);
    setAddState(false);
    setEditRowData();
    setDisabledButton(false);
    setNewData([newRow]);
    setUpdatedStatus(false);
  };

  //handle input fields changes
  const handlesFieldsChange = (fieldName, value) => {
    if (addState) {
      setNewData((data) => [{ ...data[0], [fieldName]: value }]);
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    } else {
      //else Edit State
      setEditRowData({ ...editRowData, [fieldName]: value });
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    }
  };

  //handle Add Button
  const handleAdd = () => {
    setAddState(true);
    setDisabledButton(true);
    setUpdatedStatus(true);
  };

  //handle Edit Button
  const handleEdit = (rowData) => {
    setEditState(true);
    setDisabledButton(true);
    setEditRowData({ ...rowData });
    setUpdatedStatus(rowData.isActive);
  };

  //save changes
  const handleSave = () => {
    setOpenModal(false);
    if (addState) {
      addMGA(
        { ...newData },
        {
          onSuccess: (res) => {
            setDisabledButton(false);
            if (res.data === "duplicate") {
              toast.fire("Failed", "MGA already exist", "error");
            } else if (res.status === 201) {
              setAddState(false);
              setNewData([newRow]);
              queryClient.invalidateQueries("GetMGAList");
              toast.fire("Success", "New MGA added successfully", "success");
            } else {
              toast.fire("Failed", "Server Error: Cannot add new MGA", "error");
            }
          },
          onError: (error) => {
            if (
              error.response.data.message === "Failed sending of email" ||
              error.response.data.message === "Failed inserting of notification"
            ) {
              toast.fire(
                "Success",
                "New MGA added successfully, but " +
                  error.response.data.message,
                "warning"
              );
              queryClient.invalidateQueries("GetMGAList");
            } else {
              toast.fire("Failed", "Server Error: Cannot add new MGA", "error");
            }
          },
        }
      );
    } else {
      //else for if c
      const mgaName = editRowData.mga1.trim();
      const mgaDatas = mGAData.filter((x) => x.mga1 === mgaName);

      if (
        mgaName === mgaDatas[0]?.mga1 &&
        editRowData.isActive === mgaDatas[0]?.isActive
      ) {
        toast.fire("Saving Failed", "No Changes have been made", "warning");
        setOpenModal(false);
      } else {
        editMGA(editRowData);
      }
    }
  };
  useEffect(() => {
    setSelectedRows([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.id);
    BulkDeleteMGA(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  //validation
  useEffect(() => {
    if (newData[0].mga1?.length > 0 || editRowData?.mga1?.length > 0) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [newData[0], editRowData]);

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "MGAs" : "MGA"
    }?`}</div>
  );

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setMgaFilteredData(result);
          setMgaId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  const matColumns = [
    {
      title: "MGA",
      field: "mga1",
      customSort: (a, b) =>
        a.mga1 && b.mga1
          ? a.mga1.trim().localeCompare(b.mga1.trim())
          : a.mga1
          ? 0
          : -1,
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <div className="w-full">
            <div className="">
              <TextInput
                defaultValue={rowData.mga1}
                onChange={(e) => handlesFieldsChange("mga1", e.target.value)}
              />
            </div>
          </div>
        ) : (
          <div className="w-full text-quinary font-bold uppercase text-base">
            {rowData.mga1}
          </div>
        );
      },
    },
    {
      title: "Created By",
      align: "left",
      field: "createdBy",
      hidden: addState || editState,
    },
    {
      title: "Created Date",
      align: "left",
      field: "createdOn",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.createdOn
              ? new Date(rowData.createdOn).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      title: "Modified By",
      align: "left",
      field: "modifiedBy",
      hidden: addState || editState,
    },
    {
      title: "Modified Date",
      align: "left",
      field: "modifiedOn",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.modifiedOn
              ? new Date(rowData.modifiedOn).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      field: "isActive",
      align: "left",
      title: "Status",
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <div className="flex justify-left place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handlesFieldsChange("isActive", e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {updatedStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      hidden: addState,
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <div className="flex justify-center space-x-1">
            <SaveButton
              buttonText="Save"
              disabled={
                disableSave ||
                (rowData?.mga1 === editRowData?.mga1 &&
                  rowData?.isActive === editRowData?.isActive)
              }
              onClick={() => setOpenModal(true)}
            />
            <CancelButton onClick={() => handleCancel()} />
          </div>
        ) : (
          <div className=" flex items-center place-content-center mr-5">
            {userPermissions.includes(hasEdit) && (
              <EditButton
                disabled={editState || selectedRows.length > 0}
                onClick={() => {
                  handleEdit(rowData);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];
  return (
    <div className="bg-white p-4 ">
      {!addState && (
        <>
          <div className="flex flex-row justify-between items-center">
            <TableFilters
              setMgaFilteredData={setMgaFilteredData}
              setCProgramFilteredData={setCProgramFilteredData}
              setLOBTypeFilteredData={setLOBTypeFilteredData}
              setProdCodeTypeFilteredData={setProdCodeTypeFilteredData}
              setDisChannelFilteredData={setDisChannelFilteredData}
              setCodeLevelFilteredData={setCodeLevelFilteredData}
              setFilterText={setFilterText}
              placeholder="MGA"
              disabledButton={editState || selectedRows.length > 0}
            />

            <div className="">
              {userPermissions.includes(hasAdd) && (
                <AddButton
                  buttonText="New MGA"
                  className={
                    selectedRows.length > 0 || editState
                      ? "opacity-50 float-right"
                      : "opacity-100 float-right"
                  }
                  onClick={() => handleAdd()}
                  disabled={editState || selectedRows.length > 0}
                />
              )}
            </div>
          </div>
          <div>
            <div>
              {userPermissions.includes(hasDelete) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>
          </div>
        </>
      )}
      <div
        className={
          addState ? "px-3 py-2 border-l-2  border-primary box-shadow" : ""
        }
      >
        {addState && (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold">
                Add New MGA
              </div>
              <div className="flex justify-center space-x-1">
                <SaveButton
                  buttonText="Save"
                  disabled={disableSave}
                  onClick={() => setOpenModal(true)}
                />
                <CancelButton onClick={() => handleCancel()} />
              </div>
            </div>

            <div className="h-0.5 w-full border-b-2 border-secondary " />
          </div>
        )}
        <div className={addState ? "py-2" : ""}>
          <MaterialProducerCodeConfigTable
            data={
              addState
                ? newData
                : mgaFilteredData?.length > 0
                ? mgaFilteredData
                : mGAData
            }
            isLoading={MGAData.isFetching}
            columns={matColumns}
            isDeactivate={true}
            onSelectionChange={handleSelectedRowsChange}
            selectedRows={selectedRows}
            selection={
              !addState && !editState && userPermissions.includes(hasDelete)
            }
            setOpenModal={setOpenModalDelete}
            paging={!addState}
          />
          <div>
            <ConfirmBoxModal
              ModalTitle={addState ? "Add MGA" : "Update MGA"}
              qConfirmation={
                addState
                  ? "Are you sure you want to Add this?"
                  : " Are you sure you want to Update this?"
              }
              isOpen={openModal}
              onClose={() => setOpenModal(false)}
              onClickFunction={() => {
                handleSave();
              }}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate MGA"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MGATable;
